// EstimateBudgetPhase Component
import { DragSource as dragSource, DropTarget as dropTarget } from 'react-dnd'
import ReactDom from 'react-dom'

import EstimateBudgetPhaseBase from './estimate_budget_phasebase.jsx'

const phaseSource = {
  beginDrag (props, _monitor) {
    const phase = props.phase
    phase.orgIndex = props.getPhaseIndex(phase.dragId)

    return phase
  },
  endDrag (props, monitor) {
    const phase = monitor.getItem()
    const didDrop = monitor.didDrop()

    if (phase.dragItemType === 'phase') {
      if (!didDrop) {
        if (props.onMovePhase) {
          const currentIndex = props.getPhaseIndex(phase.dragId)
          props.onMovePhase(phase, currentIndex, phase.orgIndex)
        }
      } else {
        if (props.onSavePhaseDrop) {
          props.onSavePhaseDrop()
        }
      }
    }
  }
}

const phaseTarget = {
  drop (props, monitor) {
    const item = monitor.getItem()
    if (
      item.dragItemType === 'item' &&
      props.phase &&
      props.phase.groups.length > 0 &&
      props.onDropItem
    ) {
      if (item.type !== 'pagebreak' || props.phase.groups[0].items.length > 1) {
        if (props.phase.id !== item.phaseId) {
          props.onMoveItem(
            item.phaseId,
            item.groupId,
            props.phase.id,
            props.phase.groups[0].id,
            null,
            item,
            null
          )
        }

        props.onDropItem()
      } else {
        // Revert to original position, if pagebreak not placed in between items
        props.onMoveItem(
          item.phaseId,
          item.groupId,
          item.orgPhaseId,
          item.orgGroupId,
          null,
          item,
          item.orgIndex
        )
      }
    }
  },
  hover (props, monitor, component) {
    const phase = monitor.getItem()
    const overId = props.phase.dragId

    const currentIndex = props.getPhaseIndex(phase.dragId)

    const overIndex = props.getPhaseIndex(overId)

    const boundingRect = ReactDom.findDOMNode(
      component
    ).getBoundingClientRect()
    const clientOffset = monitor.getClientOffset()
    const ownMiddleY = boundingRect.bottom - boundingRect.top
    const offsetY = clientOffset.y - boundingRect.top

    if (currentIndex < overIndex && offsetY < ownMiddleY - 80) {
      return
    }

    if (currentIndex > overIndex && offsetY > 80) {
      return
    }

    if (
      phase.dragItemType === 'phase' &&
      props.onMovePhase &&
      phase.dragId !== overId
    ) {
      props.onMovePhase(phase, currentIndex, overIndex)
    }
  }
}

@dropTarget((_props) => 'all', phaseTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop()
}))
@dragSource((_props) => 'all', phaseSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging(),
  dragPhaseItem: monitor.getItem()
}))
class EstimateBudgetPhase extends EstimateBudgetPhaseBase {
  render () {
    const { connectDragPreview, connectDropTarget } = this.props
    return connectDragPreview(connectDropTarget(super.render()))
  }
}

export default EstimateBudgetPhase
